/** Public-launch flags. Keep in sync with backend/config/launch.py */

export const LAUNCH = {
  attorneyReviewPurchases: false,
  rfePurchases: false,
  pathwaySwitchPurchases: false,
  showPolicyAlerts: false,
};

/** Baked at build time. Flip to `live` only after sk_live keys are in backend/.env. */
export const STRIPE_TEST_MODE = (process.env.REACT_APP_STRIPE_MODE || 'test') !== 'live';

export const COMING_SOON_FEATURES = [
  'Case strength scoring',
  'Deadline tracking',
  'RFE parsing and response',
  'Community data',
  'Priority date intelligence and pathway switching',
];
